import _extends from "@babel/runtime/helpers/esm/extends";
var ListReducer = function ListReducer(state, action) {
  var _action$payload = action.payload,
    payload = _action$payload === void 0 ? {} : _action$payload;
  var draggingIndex = payload.draggingIndex,
    targetDropIndex = payload.targetDropIndex,
    currentIndex = payload.currentIndex,
    listItemRef = payload.listItemRef,
    index = payload.index,
    draggable = payload.draggable,
    currentDraggingIndex = payload.currentDraggingIndex,
    itemKeydownHandler = payload.itemKeydownHandler;
  var data = state.data,
    listItemRefList = state.listItemRefList,
    keydownHandler = state.keydownHandler;
  var nextData = Array.from(data);
  switch (action.type) {
    case 'triggerIsOnKeyboardDragging':
      if (state.currentDraggingIndex === null) {
        //initial status
        return _extends({}, state, {
          isOnKeyboardDragging: true,
          currentDraggingIndex: currentDraggingIndex
        });
      } else {
        //stay in current item, press trigger
        if (state.currentDraggingIndex === currentDraggingIndex) {
          return _extends({}, state, {
            isOnKeyboardDragging: !state.isOnKeyboardDragging,
            currentDraggingIndex: null
          });
        } else {
          //move to another item, press trigger
          if (state.isOnKeyboardDragging) {
            return _extends({}, state, {
              currentDraggingIndex: currentDraggingIndex
            });
          } else {
            return _extends({}, state, {
              currentDraggingIndex: currentDraggingIndex,
              isOnKeyboardDragging: true
            });
          }
        }
      }
    case 'setDraggable':
      return _extends({}, state, {
        draggable: draggable
      });
    case 'setDynamicData':
      return _extends({}, state, {
        data: payload.data
      });
    case 'updateListItemRefList':
      var nextListItemRefList = Array.from(listItemRefList);
      nextListItemRefList[index] = listItemRef;
      if (state.draggable) {
        var nextKeyboardHandler = keydownHandler ? Array.from(keydownHandler) : [];
        nextKeyboardHandler[index] = itemKeydownHandler;
        return _extends({}, state, {
          listItemRefList: nextListItemRefList,
          keydownHandler: nextKeyboardHandler
        });
      }
      return _extends({}, state, {
        listItemRefList: nextListItemRefList
      });
    case 'setDataOnKeyUp':
      var targetDropIndexUp = currentIndex;
      if (currentIndex === 0) {
        targetDropIndexUp = data.length - 1;
      } else {
        targetDropIndexUp = targetDropIndexUp - 1;
      }
      var tempUp = nextData[targetDropIndexUp];
      nextData[targetDropIndexUp] = nextData[currentIndex];
      nextData[currentIndex] = tempUp;
      return _extends({}, state, {
        data: nextData
      });
    case 'setDataOnKeyDown':
      var targetDropIndexDown = currentIndex;
      if (currentIndex === data.length - 1) {
        targetDropIndexDown = 0;
      } else {
        targetDropIndexDown = targetDropIndexDown + 1;
      }
      var tempDown = nextData[targetDropIndexDown];
      nextData[targetDropIndexDown] = nextData[currentIndex];
      nextData[currentIndex] = tempDown;
      return _extends({}, state, {
        data: nextData
      });
    case 'setDataOnDrop':
      var result = Array.from(nextData);
      var _result$splice = result.splice(draggingIndex, 1),
        removed = _result$splice[0];
      result.splice(targetDropIndex, 0, removed);
      return _extends({}, state, {
        data: result
      });
    case 'resetDraggingItem':
      return _extends({}, state, {
        currentDraggingIndex: null,
        currentDraggingItem: null
      });
    default:
      return _extends({}, state);
  }
};
export default ListReducer;